import React from "react";
import { useTranslation } from "react-i18next";

import { capitalizeFirstLetter } from "helpers/string";

import TableCell from "components/Tables/TableCell";

export default function FreigtTransportData({ content = {} }) {
    const { t } = useTranslation();

    // Handle bodytypes as array of objects with { id, value }
    const MAX_VISIBLE_BODYTYPES = 4;
    const bodytypes = content.bodytypes || [];
    const hasMoreBodytypes = bodytypes.length > MAX_VISIBLE_BODYTYPES;
    const visibleBodytypes = bodytypes.slice(0, MAX_VISIBLE_BODYTYPES);
    const remainingCount = bodytypes.length - MAX_VISIBLE_BODYTYPES;

    const mainType = visibleBodytypes.length > 0
        ? visibleBodytypes.map(bt => capitalizeFirstLetter(bt.value)).join(", ") +
          (hasMoreBodytypes ? ` +${remainingCount}` : "")
        : "";
    const allBodytypesTitle = bodytypes.map(bt => capitalizeFirstLetter(bt.value)).join(", ");

    const additionalType = content.bodytype_additional?.value
        ? capitalizeFirstLetter(content.bodytype_additional.value)
        : "";

    // Строка 1: Тип кузова
    const combinedTitle = [mainType, additionalType].filter(Boolean).join(", ");
    const fullTitle = [allBodytypesTitle, additionalType].filter(Boolean).join(", ");

    // Строка 2: Сцепка, Пневмоход, Коники (если активны)
    const extras = [];
    if (content.hitch) {
        extras.push(t("cargoFields.transport_section.coupling_box"));
    }
    if (content.air_passage) {
        extras.push(t("cargoFields.transport_section.compressed_air_box"));
    }
    if (content.conics) {
        extras.push(t("cargoFields.transport_section.bolster_box"));
    }
    const description = extras.join(", ");

    return (
        <TableCell
            title={combinedTitle}
            titleTooltip={hasMoreBodytypes ? fullTitle : undefined}
            description={description}
        />
    );
}
